var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillingAndInspection3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 751.39 764.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9caab2;}.cls-2{fill:#b8bcc0;}.cls-3{fill:#ccd6e5;}.Graphic-Style-2,.cls-4{fill:#8ab3ff;}.cls-5{fill:#343f42;}.cls-6{fill:#588df0;}.cls-13,.cls-15,.cls-26,.cls-27,.cls-29,.cls-7{fill:none;}.cls-7{stroke:#588df0;}.cls-13,.cls-15,.cls-16,.cls-26,.cls-27,.cls-29,.cls-7{stroke-miterlimit:10;}.cls-8{fill:#828282;}.cls-9{fill:#303b3e;}.cls-10{fill:#f44d4d;}.cls-11{fill:#f66562;}.cls-12{fill:#d0d6e2;}.cls-13{stroke:#303b3e;}.cls-14,.cls-16{fill:#d0d6e0;}.cls-15,.cls-16{stroke:#343f42;}.cls-17{opacity:0.4;}.cls-18{fill:#1f6aad;}.cls-19{fill:#1f69ad;}.cls-20{fill:#257ac1;}.cls-21{fill:#b8bcc1;}.cls-22{fill:#176096;}.Graphic-Style-2{opacity:0.5;mix-blend-mode:screen;}.cls-23{fill:#cbd5e4;}.cls-24{fill:#b9bdc1;}.cls-25{fill:#dce2ec;}.cls-26,.cls-27{stroke:#727f89;}.cls-26{stroke-width:2px;}.cls-28{fill:#4b606d;}.cls-29{stroke:#4b606d;}.cls-30{isolation:isolate;}.cls-31{fill:#9aadca;}.cls-32{fill:#afc4e2;}.cls-33{fill:#788bb2;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02b",
    "data-name": "Interface_02b",
    viewBox: "0 0 33.25 48.54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.65 12.54 6.65 48.54 33.25 39.9 33.25 3.9 6.65 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.56 0 33.25 3.9 6.65 12.54 0 8.7 26.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 8.7 6.65 12.54 6.65 48.54 0 44.7 0 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.27 10.14 23.27 25.14 29.93 22.98 29.93 7.98 23.27 10.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "23.27 28.14 23.27 40.14 29.93 37.98 29.93 25.98 23.27 28.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 9.97,
    y1: 17.46,
    x2: 19.85,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 9.97,
    y1: 20.46,
    x2: 19.85,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 9.97,
    y1: 23.46,
    x2: 19.85,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "9.97 29.46 19.95 26.22 19.95 41.22 9.97 44.46 9.97 29.46"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "LabCabinet_01b",
    "data-name": "LabCabinet_01b",
    viewBox: "0 0 263 325.15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("image", {
    width: 263,
    height: 152,
    transform: "translate(0 173.15)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "166.59 90.84 196.51 108.12 215.51 179.09 226.44 185.39 203.16 102.96 159.94 78 159.94 147 166.59 150.84 166.59 90.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "96.76 272.53 96.76 284.53 103.41 288.37 113.39 285.13 113.39 276.13 96.76 272.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "40.24 239.89 40.24 251.89 46.89 255.73 56.87 252.49 56.87 243.49 40.24 239.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "206.49 236.88 206.49 248.88 213.14 252.72 223.11 249.47 223.11 240.47 206.49 236.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "36.91 186.97 103.41 225.37 226.44 185.39 159.94 147 36.91 186.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "226.44 242.39 103.41 282.37 103.41 225.37 226.44 185.39 226.44 242.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "36.91 186.97 103.41 225.37 103.41 282.37 36.91 243.97 36.91 186.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "50.22 188.65 103.41 219.37 213.14 183.72 159.94 153 50.22 188.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "159.94 147 36.91 186.97 36.91 117.97 159.94 78 159.94 147"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "80.14 142.93 203.16 102.96 226.44 185.39 103.41 225.37 80.14 142.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "166.59 90.84 166.59 150.84 215.51 179.09 196.51 108.12 166.59 90.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "159.94 0 36.91 39.97 80.14 64.93 203.16 24.96 159.94 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "36.91 39.97 80.14 64.93 80.14 142.93 36.91 117.97 36.91 39.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "203.16 24.96 203.16 102.96 80.14 142.93 80.14 64.93 203.16 24.96"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Interface_01b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.79 74.77 146.64 55.32 146.64 100.32 86.79 119.77 86.79 74.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "94.44 85.33 129.08 74.08 129.02 102 94.44 113.23 94.44 85.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.08,75.45,128,101.27,95.44,111.85V86.06l32.64-10.61m2-2.75L93.44,84.61v30L130,102.72l.08-30Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "116.71 83.04 126.69 79.8 126.69 97.8 116.71 101.04 116.71 83.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.09,
    y1: 88.45,
    x2: 113.39,
    y2: 84.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.09,
    y1: 94.45,
    x2: 113.39,
    y2: 90.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.09,
    y1: 100.45,
    x2: 113.39,
    y2: 96.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.09,
    y1: 106.45,
    x2: 113.39,
    y2: 102.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "131.71 72.17 131.71 102.17 141.68 98.93 141.68 68.93 131.71 72.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.26,80.87a2.72,2.72,0,0,1-2.74-2.82A4.49,4.49,0,0,1,96.58,74a3.32,3.32,0,0,1,1.06-.18,2.72,2.72,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.1A3.61,3.61,0,0,1,96.26,80.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M101.76,77.11l-3.21-1.85A1.74,1.74,0,0,0,97,75.1a3.35,3.35,0,0,0-2.23,3,1.61,1.61,0,0,0,.53,1.26l3.58,2.09a1.83,1.83,0,0,0,1.45.08,3.37,3.37,0,0,0,2.23-3A1.56,1.56,0,0,0,101.76,77.11Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 100.28,
    cy: 79.25,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-25.06 104.28) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M106.24,77.63a2.72,2.72,0,0,1-2.75-2.82,4.53,4.53,0,0,1,3.06-4.1,3.66,3.66,0,0,1,1.06-.17,2.72,2.72,0,0,1,2.75,2.82,4.53,4.53,0,0,1-3.06,4.1A3.66,3.66,0,0,1,106.24,77.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M111.73,73.87,108.53,72a1.75,1.75,0,0,0-1.6-.16,3.34,3.34,0,0,0-2.23,3,1.64,1.64,0,0,0,.52,1.26l3.59,2.09a1.8,1.8,0,0,0,1.44.08,3.37,3.37,0,0,0,2.23-3A1.54,1.54,0,0,0,111.73,73.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 110.25,
    cy: 76.01,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-19.08 110.74) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.3,74.71a2.4,2.4,0,0,1-2.44-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,114.3,74.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 114.99,
    cy: 71.46,
    rx: 2.62,
    ry: 1.9,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -13.95, 112.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M121,72.55A2.4,2.4,0,0,1,118.51,70a4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,121,72.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 121.64,
    cy: 69.3,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-9.96 117.06) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M127.6,70.39a2.4,2.4,0,0,1-2.44-2.52A4.26,4.26,0,0,1,128,64.06a3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,127.6,70.39Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 128.29,
    cy: 67.14,
    rx: 2.62,
    ry: 1.9,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -5.97, 121.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.16,79.61a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16A2.4,2.4,0,0,1,140,75.64a4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,136.16,79.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 136.85,
    cy: 76.36,
    rx: 2.62,
    ry: 1.9,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -9.99, 131.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.16,88.61a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16A2.4,2.4,0,0,1,140,84.64a4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,136.16,88.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 136.85,
    cy: 85.36,
    rx: 2.62,
    ry: 1.9,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -16.84, 134.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.16,97.61a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16A2.4,2.4,0,0,1,140,93.64a4.25,4.25,0,0,1-2.85,3.81A3,3,0,0,1,136.16,97.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 136.85,
    cy: 94.36,
    rx: 2.62,
    ry: 1.9,
    transform: "matrix(0.65, -0.76, 0.76, 0.65, -23.7, 137.46)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 133.34,
    y1: 82.2,
    x2: 139.99,
    y2: 80.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 133.34,
    y1: 91.04,
    x2: 139.99,
    y2: 88.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 133.34,
    y1: 100.16,
    x2: 139.99,
    y2: 98
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_15",
    "data-name": "New Symbol 15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "156.61 58.08 156.61 94.08 183.21 85.44 183.21 49.44 156.61 58.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.24 55.68 173.24 70.68 179.89 68.52 179.89 53.52 173.24 55.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "173.24 73.68 173.24 85.68 179.89 83.52 179.89 71.52 173.24 73.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 159.94,
    y1: 63,
    x2: 169.81,
    y2: 59.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 159.94,
    y1: 66,
    x2: 169.81,
    y2: 62.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 159.94,
    y1: 69,
    x2: 169.81,
    y2: 65.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "159.94 75 169.91 71.76 169.91 86.76 159.94 90 159.94 75"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.23,185c-1.55-5.46-6.17-9.26-11.24-9.26a9.93,9.93,0,0,0-3.15.5c-5.92,1.92-9.19,8.93-7.29,15.63,1.55,5.45,6.18,9.26,11.25,9.26a9.92,9.92,0,0,0,3.14-.5C118.86,198.73,122.13,191.72,120.23,185Zm-8,13.54c-4.81,1.57-10-1.69-11.59-7.27s1-11.38,5.85-12.94,10,1.69,11.59,7.27S117.08,197,112.26,198.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147,176.24c-1.55-5.45-6.17-9.26-11.24-9.26a10.32,10.32,0,0,0-3.15.5c-5.92,1.92-9.19,8.94-7.28,15.63,1.54,5.46,6.17,9.27,11.24,9.27a10.21,10.21,0,0,0,3.14-.5C145.6,190,148.87,182.94,147,176.24Zm-8,13.54c-4.81,1.57-10-1.69-11.59-7.27s1-11.37,5.85-12.94,10,1.69,11.6,7.27S143.81,188.22,139,189.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M178.62,166.13c-1.55-5.45-6.18-9.26-11.25-9.26a9.92,9.92,0,0,0-3.14.5c-5.92,1.92-9.19,8.93-7.29,15.63,1.55,5.46,6.17,9.27,11.24,9.27a10.22,10.22,0,0,0,3.15-.5C177.25,179.84,180.52,172.83,178.62,166.13Zm-8,13.54c-4.82,1.57-10-1.69-11.6-7.27s1-11.38,5.86-12.94,10,1.69,11.59,7.27S175.46,178.11,170.65,179.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.68,157.35c-1.55-5.45-6.17-9.26-11.24-9.26a10.27,10.27,0,0,0-3.15.5c-5.92,1.92-9.19,8.94-7.28,15.63,1.54,5.46,6.17,9.27,11.24,9.27a10.21,10.21,0,0,0,3.14-.5C203.31,171.06,206.58,164.05,204.68,157.35Zm-8,13.54c-4.81,1.57-10-1.69-11.59-7.27s1-11.37,5.85-12.94,10,1.69,11.6,7.27S201.53,169.33,196.71,170.89Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "36.91 117.97 36.91 186.97 103.41 225.37 80.14 142.93 36.91 117.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "43.56 130.81 73.49 148.09 92.49 219.06 103.41 225.37 80.14 142.93 36.91 117.97 36.91 186.97 43.56 190.81 43.56 130.81"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "translate(114.5 220.69)",
    xlinkHref: "#Interface_02b"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_01b-2",
    "data-name": "Interface_01b",
    viewBox: "0 0 69.82 70.2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.97 25.2 69.82 5.76 69.82 50.76 9.97 70.2 9.97 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.97 25.2 0 19.45 0 64.45 9.97 70.2 9.97 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.82 5.76 9.97 25.2 0 19.45 59.85 0 69.82 5.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "17.63 35.77 52.27 24.52 52.2 52.43 17.63 63.67 17.63 35.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.26,25.89,51.2,51.71,18.62,62.29V36.5L51.26,25.89m2-2.75L16.62,35V65L53.2,53.16l.07-30Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "39.9 33.48 49.87 30.24 49.87 48.24 39.9 51.48 39.9 33.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 38.88,
    x2: 36.57,
    y2: 34.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 44.88,
    x2: 36.57,
    y2: 40.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 50.88,
    x2: 36.57,
    y2: 46.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 56.88,
    x2: 36.57,
    y2: 52.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "54.89 22.61 54.89 52.61 64.86 49.37 64.86 19.37 54.89 22.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.45,31.31a2.72,2.72,0,0,1-2.75-2.82,4.53,4.53,0,0,1,3.06-4.1,3.67,3.67,0,0,1,1.07-.17A2.72,2.72,0,0,1,23.57,27a4.53,4.53,0,0,1-3.06,4.1A3.66,3.66,0,0,1,19.45,31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.94,27.55l-3.2-1.85a1.78,1.78,0,0,0-1.6-.17,3.36,3.36,0,0,0-2.23,3,1.6,1.6,0,0,0,.52,1.25L22,31.84a1.81,1.81,0,0,0,1.44.07A3.35,3.35,0,0,0,25.69,29,1.54,1.54,0,0,0,24.94,27.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 23.46,
    cy: 29.68,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-14.35 28.32) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.42,28.07a2.72,2.72,0,0,1-2.74-2.82,4.51,4.51,0,0,1,3.06-4.1A3.61,3.61,0,0,1,30.8,21a2.72,2.72,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.1A3.61,3.61,0,0,1,29.42,28.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.92,24.31l-3.21-1.85a1.77,1.77,0,0,0-1.6-.17,3.37,3.37,0,0,0-2.23,3,1.59,1.59,0,0,0,.53,1.25L32,28.6a1.83,1.83,0,0,0,1.45.07,3.35,3.35,0,0,0,2.23-3A1.56,1.56,0,0,0,34.92,24.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 33.44,
    cy: 26.44,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-8.37 34.78) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.49,25.15a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52A4.26,4.26,0,0,1,38.46,25,3.34,3.34,0,0,1,37.49,25.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 38.18,
    cy: 21.9,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-3.24 36.79) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.14,23a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16A2.4,2.4,0,0,1,48,19a4.26,4.26,0,0,1-2.85,3.81A3.39,3.39,0,0,1,44.14,23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 44.83,
    cy: 19.74,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(0.75 41.1) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.79,20.83a2.4,2.4,0,0,1-2.44-2.52,4.27,4.27,0,0,1,2.85-3.82,3.32,3.32,0,0,1,1-.15,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.39,3.39,0,0,1,50.79,20.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 51.48,
    cy: 17.58,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(4.73 45.4) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,30.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,30.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 26.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(0.72 55.16) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,39.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,39.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 35.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-6.13 58.33) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,48.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,48.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 44.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-12.99 61.5) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 32.64,
    x2: 63.17,
    y2: 30.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 41.47,
    x2: 63.17,
    y2: 39.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 50.6,
    x2: 63.17,
    y2: 48.44
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Poster_01b",
    "data-name": "Poster_01b",
    viewBox: "0 0 36.57 77.88"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "0 11.88 0 77.88 36.57 66 36.57 0 0 11.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 6.65,
    y1: 18.72,
    x2: 29.92,
    y2: 11.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 6.65,
    y1: 27.72,
    x2: 29.92,
    y2: 20.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 6.65,
    y1: 36.72,
    x2: 29.92,
    y2: 29.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 6.65,
    y1: 45.72,
    x2: 29.92,
    y2: 38.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 6.65,
    y1: 54.72,
    x2: 29.92,
    y2: 47.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 6.65,
    y1: 63.72,
    x2: 29.92,
    y2: 56.16
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Watch_01b",
    "data-name": "Watch_01b",
    viewBox: "0 0 38.14 45.37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 15.75,
    cy: 20.76,
    rx: 21.48,
    ry: 14.75,
    transform: "translate(-9.24 28.16) rotate(-69.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 22.39,
    cy: 24.6,
    rx: 21.48,
    ry: 14.75,
    transform: "translate(-8.53 36.87) rotate(-69.32)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-29",
    points: "23.27 12.32 23.27 24.32 33.17 30.26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overblik"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "707.5 561.46 698.72 556.39 698.72 461.35 707.45 458.48 707.5 561.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "637.27 528.84 645.88 533.83 645.88 450.87 637.54 453.5 637.27 528.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "637.27 528.84 545.11 558.78 545.11 566.7 645.88 533.83 637.27 528.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "523.6 490.46 523.33 565.79 531.94 570.78 531.94 487.82 523.6 490.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "523.33 565.79 431.17 595.74 431.17 603.66 531.94 570.78 523.33 565.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Graphic-Style-2",
    d: "M645.88,533.83,545.11,566.7V483.54l100.77-32.67Zm-113.94-46L431.17,520.5v83.16l100.77-32.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M545.22,614.19l116.19-37.76v-103l46.09-15v103l43.89-14.26-2.2-145.81L78.77,619.31V765Zm-.11-130.65,100.77-32.67v83L545.11,566.7Zm-13.17,4.28v83L431.17,603.66V520.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "69.91 614.19 78.77 619.3 749.19 401.39 731.63 399.18 69.91 614.19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fyldning_Inspektion_02",
    "data-name": "Fyldning & Inspektion 02"
  }, /*#__PURE__*/React.createElement("use", {
    width: 263,
    height: 325.15,
    transform: "translate(14.08 4.32) scale(0.64)",
    xlinkHref: "#LabCabinet_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 69.82,
    height: 70.21,
    transform: "translate(166.41) scale(0.64)",
    xlinkHref: "#Interface_01b-2"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "translate(189.84 40.74) scale(0.64)",
    xlinkHref: "#Interface_02b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 36.57,
    height: 77.88,
    transform: "translate(0 62.22) scale(0.64)",
    xlinkHref: "#Poster_01b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager_03",
    "data-name": "Kontor & Lager 03"
  }, /*#__PURE__*/React.createElement("use", {
    width: 36.57,
    height: 77.88,
    transform: "translate(711.95 453.67) scale(0.64)",
    xlinkHref: "#Poster_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 38.14,
    height: 45.37,
    transform: "translate(667.26 426.59) scale(0.64)",
    xlinkHref: "#Watch_01b"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "translate(399.92 546.17) scale(0.64)",
    xlinkHref: "#Interface_02b"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "78.77 764.97 69.91 759.85 69.91 614.19 78.77 619.3 78.77 764.97"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillingAndInspection3);
export default __webpack_public_path__ + "static/media/filling-and-inspection-3.d92ea3d45225f219b586c8ea1892ecdc.svg";
export { ForwardRef as ReactComponent };